export const BUSINESS_TYPE =
  "Indicate if the test request is intended to form a new relationship with a customer, to maintain an existing " +
  "relationship with a customer, or for analysis without an associated customer.";

export const PRIORITY = "Indicate the priority of the test request.";

export const CSC_EVALUATION = "The assigned CSC lab member is responsible to evaluate the Test Request.";

export const CUSTOMER_VALUE_CHAIN = "Enter the Customer we are directly selling to.";

export const REPORT_USAGE =
  "Indicate if the report is intended for customers (external) or only for use at tesa (internal).";

export const TEST_LOCATION = "Indicate if the tests are to be executed in a tesa CSC lab or an external lab.";

export const TEST_PROGRAM = "Describe the tests which need to be executed in this test request.";

export const infoCscLaboratory = (editable: boolean | undefined, newOrDraft: boolean) => {
  return newOrDraft || !editable
    ? "Indicate the CSC lab responsible for the test request and have access to it."
    : `
  * Indicate the CSC lab responsible for the test request and have access to it.
  * Please use Assign-Function to adjust lab and assignee.
  `;
};

export const infoIsAssignedToRequest =
  "The assigned lab member can accept the Test Request. *The status is changed to In Preparation. In this state only" +
  " the assigned CSC lab member can edit the Test Request and can start with the test planning and execution. *The" +
  " assigned lab member can also decline the Test Request. *The assigned lab member and the requester can cancel an" +
  " accepted Test Request at any time";

export const infoAssignToRequest =
  "Only one person in the CSC lab is able to work on a Test Request. *The lab member who wants to work on a Test" +
  " Request can assign themself to the request here. *Every member of the CSC lab can see whether there is someone " +
  "assigned to a Test Request. *The assigned user can be changed by clicking on “Assign” again until the Test Request" +
  " is completed.";

export const infoRequestCreation =
  "After submitting, the Test Request receives the status SUBMITTED and is forwarded to the CSC. *The request can be" +
  " saved and given the status 'DRAFT'.";

export const msgSubmissionInvalid: string = "Invalid submission, please correct the highlighted fields and try again.";
export const msgSubmissionSuccessful: string = "Successfully submitted";
